import { useStartDsdReview } from "@/hooks/mutations/use-start-dsd-review";
import { DSD_EDITOR_MODE, type DsdReviewLocationState } from "@/types/dsd";
import { Button } from "@/toggle-ui-kit/button";
import { logHomeServiceAccess, logHomeWork } from "@/utils/usage-log";
import { FileSearch, Loader2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { FileDropZone } from "@/components/file-drop-zone";

// 집계에서 STEP 카드 로그와 묶이도록 steps.tsx 의 label 과 같게 쓴다
const STEP_LABEL = "DSD 검토";

/** STEP2 DSD 검토 — DSD 를 올려 리뷰를 새 탭으로 열거나, 리뷰 화면에서 기존 DSD 를 고르러 간다. */
export const DsdReviewPanel = () => {
  const [file, setFile] = useState<File | null>(null);
  const { start, isPending } = useStartDsdReview();
  const navigate = useNavigate();

  return (
    <>
      <FileDropZone
        accept=".dsd"
        hint="*.dsd 형식"
        file={file}
        onFileChange={setFile}
      />
      <div className="flex w-full items-start justify-between">
        {/* 올린 파일은 들고 가지 않는다 — 리뷰 화면의 "기존 DSD 선택" 으로 바로 연다 */}
        <Button
          size={40}
          onClick={() => {
            logHomeServiceAccess(`${STEP_LABEL} 패널`, "이전 DSD 불러오기");
            navigate("/dsd-editor", {
              state: {
                mode: DSD_EDITOR_MODE.existingReport,
              } satisfies DsdReviewLocationState,
            });
          }}
        >
          이전 DSD 불러오기
        </Button>
        <Button
          variant="solid"
          size={40}
          className="bg-blue-500"
          leftIcon={
            isPending ? (
              <Loader2 className="animate-spin" strokeWidth={1.8} />
            ) : (
              <FileSearch strokeWidth={1.8} />
            )
          }
          disabled={!file || isPending}
          onClick={() => {
            if (!file) return;
            logHomeWork(STEP_LABEL, "검토 시작");
            start(file);
          }}
        >
          검토 시작
        </Button>
      </div>
    </>
  );
};
